const DEFAULT_API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_BASE_URL = DEFAULT_API_BASE_URL.replace(/\/$/, '');

export function buildApiUrl(path = '') {
  if (!path) return API_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || 'null');
  } catch {
    return null;
  }
}

export function getAuthHeaders(extraHeaders = {}) {
  const headers = new Headers(extraHeaders);
  const storedUser = getStoredUser();

  if (storedUser?.token) {
    headers.set('Authorization', `Bearer ${storedUser.token}`);
  }

  return headers;
}

export const apiFetch = async (path, options = {}) => {
  const headers = getAuthHeaders(options.headers || {});

  if (!(options.body instanceof FormData) && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(buildApiUrl(path), {
    ...options,
    headers,
  });

  if (response.status === 401) {
    // Automatically handle token expiry or invalidation
    localStorage.removeItem('userInfo');
    // Redirect to login page. Using window.location.href for a full redirect
    // which is appropriate here as we are outside of React Router context.
    window.location.href = '/login';
    // Return a promise that never resolves to stop further processing in the calling code
    return new Promise(() => {});
  }

  return response;
};

/**
 * Uploads an image file:
 * 1. Primary: Hostinger PHP script (https://finegaltechsolution.in/upload.php or current origin /upload.php)
 * 2. Fallback: Render API (/api/upload)
 */
export async function uploadImageFile(file) {
  const formData = new FormData();
  formData.append('image', file);

  // Hostinger PHP upload URL
  const hostingerUploadUrl = window.location.hostname === 'localhost'
    ? 'https://finegaltechsolution.in/upload.php'
    : `${window.location.origin}/upload.php`;

  try {
    const res = await fetch(hostingerUploadUrl, {
      method: 'POST',
      body: formData,
    });

    if (res.ok) {
      const data = await res.json();
      if (data && (data.url || data.image)) {
        return data.url || data.image;
      }
    }
  } catch (err) {
    console.warn('Hostinger PHP upload failed, falling back to backend API...', err);
  }

  // Fallback to Render backend /api/upload
  const fallbackRes = await apiFetch('/api/upload', {
    method: 'POST',
    body: formData,
  });

  if (!fallbackRes.ok) {
    throw new Error('Image upload failed on both Hostinger and fallback servers.');
  }

  const fallbackData = await fallbackRes.json();
  return fallbackData.url || fallbackData.image;
}

